import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { OuterChipsContainer, ChipsContent, StyledDivider, StyledTextChosenFilters, } from '../styles/FilterOverlay.styles';
import { ChipsList } from './ChipsList';
import { DynamicThemeProviderWrapper } from '../../utils';
export const FilterChips = ({ configuredFilters }) => {
    const chosenFiltersLabel = useI18n({
        id: `nemo.sc.filter.chosenFilters`,
        defaultMessage: 'Selected Filters',
    });
    return (React.createElement(DynamicThemeProviderWrapper, null,
        React.createElement(OuterChipsContainer, null,
            React.createElement(ChipsContent, null,
                React.createElement(StyledDivider, null),
                React.createElement(StyledTextChosenFilters, { id: "chosenfilterchipslabel" }, chosenFiltersLabel),
                React.createElement(ChipsList, { configuredFilters: configuredFilters })))));
};
export default FilterChips;
